import { Box, FormControl, FormHelperText } from '@mui/material';
import CustomFormLabel from 'src/components/forms/theme-elements/CustomFormLabel';
import CustomSelect from 'src/components/forms/theme-elements/CustomSelect';

const FormSelect = ({
  name,
  label,
  required = false,
  value,
  onChange,
  options = [],
  getOptionLabel = (option) => option.label,
  getOptionValue = (option) => option.value,
  error,
  helperText,
  isMulti = false,
  closeMenuOnSelect = true,
  ...props
}) => {
  return (
    <Box>
     
     {label && <CustomFormLabel margin="0" required={required}>{label}</CustomFormLabel>} 
      <CustomSelect
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        options={options}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        isMulti={isMulti}
        closeMenuOnSelect={closeMenuOnSelect}
        error={error}
        {...props}
      />
      {error && <FormHelperText error>{helperText}</FormHelperText>}
     
    </Box>
  );
};

export default FormSelect;